<template>
  <div id="sportsDetail_compreScore">
    <template v-if="!isNotDataFlag">
      <div class="tabMeun" v-if="tabMeun && tabMeun.length > 1">
        <span
          class="tabMeun_item"
          v-for="item in tabMeun"
          :key="item.value"
          v-text="item.name"
          :class="item.act ? 'act' : ''"
          @click="clickTabMeun(item)"
        ></span>
      </div>
      <div v-for="item in tabMeun" :key="item.value">
        <template v-if="item.value === 'groupStage'">
          <!-- 小组赛 -->
          <combat_groupStage
            :axiosBaseUrl="axiosBaseUrl"
            :currCid="currCid"
            :currSid="currSid"
            :currSportsDetail="currSportsDetail"
            :currThemeObj="currThemeObj"
            :datas="item.data"
            v-show="item.act"
          ></combat_groupStage>
        </template>
        <template v-else-if="item.value === 'knockout'">
          <!-- 淘汰赛 -->
          <combat_knockout
            :axiosBaseUrl="axiosBaseUrl"
            :currCid="currCid"
            :currSid="currSid"
            :currThemeObj="currThemeObj"
            :currSportsDetail="currSportsDetail"
            :datas="item.data"
            :sportType="sportType"
            :themeTemplateType="themeTemplateType"
            v-show="item.act"
          ></combat_knockout>
        </template>
      </div>
    </template>
    <cup_notData
      v-if="isNotDataFlag && tabMeun && tabMeun.length === 0"
      :className="'relativePtb30'"
    ></cup_notData>
    <!-- <div class="uncombatBox" v-show="computedSportsType === sportsTypeArr[1]">
      <uncombat_knockout
        :currCid="currCid"
        :currSid="currSid"
        :currSportsDetail="currSportsDetail"
        :axiosBaseUrl="axiosBaseUrl"
        :curTimeZoneItem="curTimeZoneItem"
        :currThemeObj="currThemeObj"
      ></uncombat_knockout>
      <uncombat_unknockout
        :currCid="currCid"
        :currSid="currSid"
        :currSportsDetail="currSportsDetail"
        :axiosBaseUrl="axiosBaseUrl"
        :curTimeZoneItem="curTimeZoneItem"
        :currThemeObj="currThemeObj"
      ></uncombat_unknockout>
    </div> -->
  </div>
</template>

<script>
import combat_groupStage from '@components/platfromBase/compreSportsMeet/compreScore/combat_groupStage.vue'
import combat_knockout from '@components/platfromBase/compreSportsMeet/compreScore/combat_knockout.vue'
import uncombat_knockout from '@components/platfromBase/compreSportsMeet/compreScore/uncombat_knockout.vue'
import uncombat_unknockout from '@components/platfromBase/compreSportsMeet/compreScore/uncombat_unknockout.vue'
import cup_notData from '@components/base/NO_DATA.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import { https_sportsEvent_compreScore } from '@api/platfrom_compreSportsMeet_api'
// import compreScoreData from '@components/platfromBase/compreSportsMeet/compreScore/mock.js'  // 测试数据
export default {
  name: 'sportsDetail_compreScore',
  mixins: [cup_base_data_mixin],
  components: {
    combat_groupStage,
    combat_knockout,
    cup_notData,
    // uncombat_knockout,
    // uncombat_unknockout,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    currSportsDetail: {
      handler(newVal, oldVal) {
        console.debug('重新刷新数据1:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      // immediate: false,
      deep: true,
    },
  },
  data() {
    return {
      // computedSportsType: 'combat',
      themeTemplateType: 37,
      isNotDataFlag: true,
      tabMeun: null,
      curCompreScore: '', // ['groupStage'(小组赛), 'knockout'(淘汰赛)]
      sportType: 'compreSportsMeet',
    }
  },
  created() {
    if (this.currGroup) {
      this.init()
    }
  },
  methods: {
    clickTabMeun(item) {
      this.tabMeun.forEach((ceil) => {
        if (item.value === ceil.value) {
          ceil.act = true
          this.curCompreScore = item.value
        } else {
          ceil.act = false
        }
      })
    },
    async init() {
      await this.getCompreScoreData()
    },
    compreScoreDataHandler(resData) {
      let tabMeun = []
      resData.forEach((tabItem, tabIndex) => {
        let act = false
        if (tabIndex === 0) {
          act = true
          this.curCompreScore = tabItem.type
        }
        tabMeun.push({
          value: tabItem.type,
          name: tabItem.typeName,
          data: tabItem.data,
          act,
        })
      })
      this.tabMeun = tabMeun
      console.debug('this.tabMeun:', this.tabMeun)
    },
    async getCompreScoreData() {
      let params = {
        cid: this.currCid,
        sid: this.currSid,
        sportsId: this.currSportsDetail.sportsId,
        eventId: this.currSportsDetail.eventId,
        timeZone: this.curTimeZoneItem.val,
      }
      await https_sportsEvent_compreScore(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            if (res.data && res.data.length > 0) {
              this.isNotDataFlag = false
              this.compreScoreDataHandler(res.data)
            } else {
              this.isNotDataFlag = true
              this.tabMeun = []
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#sportsDetail_compreScore {
  width: 100%;
  .tabMeun {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    padding-top: 2.788vw;
    .tabMeun_item {
      width: 15.972vw;
      height: 3.473vw;
      border: 1px solid var(--mixtmt_btn_tabMeun_actColor);
      font-size: 1.25vw;
      line-height: calc(3.473vw - 2px);
      text-align: center;
      color: var(--mixtmt_btn_tabMeun_actColor);
      &.act,
      &:hover {
        background-color: var(--mixtmt_btn_tabMeun_actColor);
        color: var(--mixtmt_whiteColor);
      }
      &:nth-child(1) {
        border-radius: 0.347vw 0 0 0.347vw;
        border-right: 0;
      }
      &:nth-child(2) {
        border-radius: 0 0.347vw 0.347vw 0;
        border-left: 0;
      }
    }
  }
}
.mixtmt_pc #sportsDetail_compreScore {
  .tabMeun_item {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
